<template>
  <div class="pdp-drawer" :content-type="contentType">
    <h3 class="pdp-drawer__title">{{ title }}</h3>
    <div
      class="pdp-drawer__body"
      v-html="content.replace('<p>&nbsp;</p>', '')"
    />
  </div>
</template>

<script>
export default {
  name: "NsProductDetailDrawer",
  props: {
    /**
     * Title of the section content
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * HTML content of the section
     */
    content: {
      type: String,
      default: ""
    },
    /**
     * Enum type of content to aid in styling the section
     * "videos", "benefits", "usage", "ingredients", "resources"
     */
    contentType: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use '~@nuskin/ns-core-styles/src/scss/colors';
@use '~@nuskin/ns-core-styles/src/scss/typographyVariables';

::-moz-selection {
  background: map.get(colors.$themeColors, color-interactive-5);
}
::selection {
  background: map.get(colors.$themeColors, color-interactive-5);
}
.pdp-drawer {
  font-size: 16px;
  line-height: 21px;
  font-family: map.get(typographyVariables.$typography, font-family-primary);
  color: map.get(colors.$themeColors, color-interactive-7);
  padding: 30px;
  background-color: map.get(colors.$themeColors, color-background-1);
}
.pdp-drawer__title {
  font-weight: map.get(typographyVariables.$typography, font-weight-normal);
  font-size: 28px;
  line-height: 34px;
  margin-bottom: 20px;
}
.pdp-drawer__body ::v-deep a {
  display: inline-block;
  margin-bottom: 20px;
  text-decoration: none !important;
}
.pdp-drawer__body ::v-deep h4 {
  font-size: 16px;
  line-height: 18px;
  font-weight: map.get(typographyVariables.$typography, font-weight-semibold);
  margin-bottom: 10px;
}
.pdp-drawer__body ::v-deep p {
  margin-bottom: 30px;
}
.pdp-drawer__body ::v-deep ul {
  display: grid;
  grid-gap: 10px;
  padding-inline-start: 30px;
}
.pdp-drawer__body ::v-deep b {
  font-weight: map.get(typographyVariables.$typography, font-weight-semibold);
}
.pdp-drawer__body ::v-deep p > a,
.pdp-drawer__body ::v-deep li > a,
.pdp-drawer__body ::v-deep .text > a {
  color: map.get(colors.$themeColors, color-interactive-7);
  font-weight: map.get(colors.$themeColors, font-weight-semibold);
  border-bottom: 1px solid currentColor;
}
.pdp-drawer__body ::v-deep video,
.pdp-drawer__body ::v-deep iframe {
  max-width: 100%;
}
.pdp-drawer[content-type="videos"] .pdp-drawer__body ::v-deep p {
  width: 100%;
  max-width: 100%;
  position: relative;
}
.pdp-drawer:not([content-type="videos"]) .pdp-drawer__body > ::v-deep * {
  max-width: 550px;
}
.pdp-drawer__body ::v-deep video.aem-video {
  background: black;
}

.pdp-drawer__body > ::v-deep *:last-child {
  margin-bottom: 0;
}

.pdp-drawer {
  ::v-deep div:empty,
  ::v-deep span:empty,
  ::v-deep h3:empty {
    display: none;
  }
}
</style>
